import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class SoundChain {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {string[]} soundNamesArray
   */
  constructor(scene, soundNamesArray) {
    this.scene = scene;

    this.soundCounter = 0;
    this.soundNames = soundNamesArray;
    this.enabled = true;
    this.sounds = [];

    this.soundObj = ABCyaPhaser.Audio.createSound(scene);
  }

  play () {
    if (!this.enabled) {
      return;
    }

    const name = this.soundNames[this.soundCounter];

    if (name === null || name === undefined) return;

    this.soundCounter++;
    ABCyaPhaser.Audio.playSound(name, this.soundObj);
    this.soundObj.once(Phaser.Sound.Events.COMPLETE, this.play, this);
  }

  stop (keepEnabled) {
    this.enabled = keepEnabled === true;
    this.soundObj.stop();
  }

  isPlaying () {
    return this.soundObj.isPlaying;
  }

  playAgain () {
    this.soundCounter = 0;
    this.play();
  }
}